import React, {useEffect, useState} from "react";
import Select from "../forms/inputs/Select";
import {useGetCompaniesQuery} from "../../api/userApiSlice";

export default function CompanySelect({value: objectValue, ...props}) {
  const {data: companies = {}, isSuccess} = useGetCompaniesQuery()

  const [ stringifiedValue, setStringifiedValue ] = useState("");

  function stringifyValue({type, id}) {
    return type + "|" + id
  }

  function objectifyValue(str) {
    return {type: str && str.split('|')[0], id: str && str.split('|')[1]}
  }

  const formatObjectAsOptionGroup = (obj) => [
    {
      label: "Data Vendors",
      options: obj["dataVendors"].map((el)=>{
        return { label: el.name, value: stringifyValue({type: "data_vendor", id: el.id}) }
      })
    }, {
      label: "Publishers",
      options: obj["publishers"].map((el)=>{
        return { label: el.name, value: stringifyValue({type: "publisher", id: el.id}) }
      })
    }
  ]

  useEffect(() => {
    setStringifiedValue(stringifyValue(objectValue))
    props.onCompanyTypeChange && props.onCompanyTypeChange(objectValue.type)
  }, [objectValue])

  const onChange = (val) => {
    props.onChange(objectifyValue(val))
  }

  return <Select isClearable={true} options={isSuccess ? formatObjectAsOptionGroup(companies) : []} {...props} onChange={onChange} value={stringifiedValue}/>
}
